function decodeLogoHtmlEntities(value) {
  return String(value || '')
    .replace(/&#x2F;/gi, '/')
    .replace(/&#47;/g, '/')
    .replace(/&amp;/g, '&');
}

/** @returns {string|null} data URL, '' si vacío, null si inválido */
export function normalizeLogoDataUrl(logo) {
  if (logo == null) return '';
  const raw = decodeLogoHtmlEntities(logo).trim();
  if (!raw) return '';

  if (/^data:image\//i.test(raw)) {
    return raw;
  }

  if (raw.startsWith('blob:') || raw.startsWith('http://') || raw.startsWith('https://')) {
    return null;
  }

  const compact = raw.replace(/\s/g, '');
  if (/^[A-Za-z0-9+/=]+$/.test(compact) && compact.length >= 32) {
    return `data:image/png;base64,${compact}`;
  }

  return null;
}

export function isValidLogoDataUrl(logo) {
  if (!logo) return true;
  return normalizeLogoDataUrl(logo) !== null;
}
